import { useEffect } from 'react';
export const useAutoExpansion = (value, initialLayout, isMobileStyle, isExpanded, setExpanded) => {
    useEffect(() => {
        // Resize if we are above the threshold OR the input contains a new line
        const threshold = isMobileStyle ? 15 : 40;
        if ((value && value.length > threshold) || value?.includes('\n')) {
            setExpanded(true);
        }
        else if (isExpanded !== (initialLayout === 'expanded')) {
            setExpanded(initialLayout === 'expanded');
        }
    }, [value, initialLayout, isMobileStyle, isExpanded, setExpanded]);
};
//# sourceMappingURL=utils.js.map